import { normalize } from 'normalizr';
import { RSAA } from 'redux-api-middleware';
import { vodContent as vodContentSchemas } from 'app-webtech-core/schemas';
import { selectors } from 'app-webtech-core/selectors';
import { FETCH_BY_SLUG } from './types';

const { VodContentSchema } = vodContentSchemas;

export const payloadResolver = ({ data }) => {
  const { result, entities } = normalize([data], [VodContentSchema]);
  return {
    result,
    entities,
  };
};

export const vodContentFetchBySlugAPIRequest = (seriesSlug, baseUrl) => ({
  [RSAA]: {
    endpoint: `${baseUrl}/v3/vod/slugs/${seriesSlug}`,
    method: 'GET',
    credentials: 'same-origin',
    types: [
      {
        type: FETCH_BY_SLUG.REQUEST,
      },
      {
        type: FETCH_BY_SLUG.SUCCESS,
        payload: (action, state, res) => res.json(),
      },
      {
        type: FETCH_BY_SLUG.FAILURE,
      },
    ],
  },
});

export const vodContentFetchBySlugAction = (serieId) => async (dispatch, getState) => {
  const state = getState();
  const vodUrl = selectors.application.servers(state).vod;
  return dispatch(vodContentFetchBySlugAPIRequest(serieId, vodUrl));
};
